/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React, { useState } from 'react';

import { ILdsContactUsViewProps } from './lds-contact-us';

import styled from 'styled-components';
import { ContactTable } from './components/ContactTable';
import { ContactCountrySelect } from './components/ContactCountrySelect';
import { ContactContent } from './components/ContactContent';

export default (props: ILdsContactUsViewProps) => {
    const [selectedCountry, setSelectedCountry] = useState({});
    const [defaultCountry, setDefaultCountry] = useState<any>({ CountryName: 'United States', EXTCODEVALUE: '1-800-537-5971' });
    const ContactUsTable = styled.div`
        font-family: Ensign:Sans;
        display: flex;
        align-content: center;
        flex-direction: column;
        flex-wrap: wrap;
        align-items: flex-start;
        width: 100%;
    `;

    const ContactWrapper = styled.div`
        width: 930px;

        @media (max-width: 930px) {
            width: 100%;
        }
    `;

    const countries = props.data.countries?.result;

    // let defaultCountry: any = { CountryName: 'United States', EXTCODEVALUE: '1-800-537-5971' };
    let userCountry: any;

    let countriesWithPhone;
    if (countries) {
        countriesWithPhone = countries.filter(country => {
            return country.EXTCODEVALUE;
        });
    }
    let sortedRegions: any;
    if (countries && countriesWithPhone) {
        sortedRegions = countriesWithPhone.sort((a, b) => (a.CountryName! > b.CountryName! ? 1 : b.CountryName! > a.CountryName! ? -1 : 0));
    }
    React.useEffect(() => {
        let currentCountry: any;
        if (props.data.cart && props.data.cart.result) {
            const userCountry: any =
                props.data.cart && props.data.cart.result && props.data.cart.result.cart.ExtensionProperties
                    ? props.data.cart.result.cart.ExtensionProperties.filter((property: any) => {
                          return property.Key === 'Country';
                      })
                    : '';

            // currentCountry = props.data.cart.result.cart.ExtensionProperties![2].Value?.StringValue;
            currentCountry = userCountry[0].Value.StringValue;
        }
        countries?.map(country => {
            if (country.countryRegionId === props.context.request.channel?.CountryRegionId) {
                setDefaultCountry(country);
            } else if (sortedRegions) {
                setDefaultCountry(sortedRegions[0]);
            }
        });

        if (countries) {
            userCountry = countries.filter(country => {
                if (currentCountry) {
                    return country.countryRegionId === currentCountry;
                } else {
                    return country.CountryName === defaultCountry.CountryName;
                }
            });
            setSelectedCountry(userCountry[0]);
        }
    }, [props.data]);

    const handleSelect = (option: string) => {
        const userCountry = countries!.filter((country: any) => {
            return country.Id.toString() === option;
        });

        setSelectedCountry(userCountry[0]);
    };

    return (
        <ContactUsTable>
            <ContactWrapper>
                <ContactContent contactHeader={props.resources.contactHeader} contactMessage={props.config.contactUsText} />
                <ContactCountrySelect
                    ContactData={props.data}
                    handleSelect={handleSelect}
                    currentCountry={selectedCountry}
                    sortedList={sortedRegions}
                    resources={props.resources}
                />
                <ContactTable selectedCountry={selectedCountry} defaultCounty={defaultCountry} resources={props.resources} />
            </ContactWrapper>
        </ContactUsTable>
    );
};
